import { HttpClient } from "@angular/common/http";
import { AbstractService } from "../commons/abstract.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SearchParams } from "../commons/abstract.types";
import { Comment } from "../models/comment.model";
import { Pager } from "../commons/pager";

@Injectable({ providedIn: 'root' })
export class CommentService extends AbstractService<any> {

  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/comment';
  }

  preCreate(obj: any): void {
    delete obj._id;
  }

  preUpdate(obj: any): void {
  }

  getByIdCard(page: number, perPage: number, search?: string, params?: Partial<SearchParams>): Observable<Pager<Comment>> {
    const baseURL = '/pager';
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;

    const getSearchConfig = (search: string): string => {
      if (!!search) {
        if (search.includes('+')) {
          const searches = search.split('+');
          let urlSearches = '';
          searches.forEach((search) => {
            urlSearches += `&search=${search}`;
          });
          return urlSearches;
        } else {
          return '&search=' + encodeURIComponent(search);
        }
      } else {
        return '';
      }
    }
    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        urling = `${urling}&${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

  getByThread(idThreadRoot: string): Observable<Comment[]> {
    return this.get(`/thread/${idThreadRoot}`);
  }

  replyComment(idParent: string, obj: Object): Observable<Comment> {
    return super.post(`/${idParent}/reply`, obj);
  }
}
